"use client";

import { useEffect, useState } from "react";

const RunningNumbersDisplay = ({ targetNumber }) => {
  const [currentNumber, setCurrentNumber] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentNumber <= targetNumber) {
        console.log(currentNumber);
        setCurrentNumber(currentNumber + 1);
      } else {
        clearInterval(intervalId);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [currentNumber, targetNumber]);

  return (
    <div>
      <p className="pro_heading">
        {currentNumber <= targetNumber ? currentNumber : targetNumber}%
      </p>
    </div>
  );
};

export default RunningNumbersDisplay;
